import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

const catalogGraphSystemDiagramContent = EntityContentBlueprint.make({
  name: 'driveline-system-diagram',
  params: {
    path: '/diagram',
    title: 'Diagram',
    filter: entity => entity.kind.toLocaleLowerCase('en-US') === 'system',
    loader: () =>
      import('./SystemDiagramEntityContent').then(module => (
        <module.SystemDiagramEntityContent />
      )),
  },
});

export const catalogGraphEntityContentModule = createFrontendModule({
  pluginId: 'catalog-graph',
  extensions: [catalogGraphSystemDiagramContent],
});
